import { CustomStyles } from '@types';

const styles: { root: CustomStyles } = {
  root: { height: '100%', padding: 0 },
};

export default styles;
